import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

//MUI
import { Box, Divider, Stack, Button, Checkbox, } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import DownloadIcon from '@mui/icons-material/Download';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

//API
import { fnExcel, fni18n } from "../../services/commonService";
import { API } from "../../config";
import { getAPI, postAPI, putAPI, deleteAPI } from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";

// custom UI
import UTable from "../../components/mui/UTable";
import UDataGrid from "../../components/mui/UDataGrid";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UTextField from "../../components/mui/UTextField";
import UButton from "../../components/mui/UButton";
import UAuthButton from "../../components/mui/UAuthButton";
import UPagination from "../../components/mui/UPagination";
import SystemMachineDetailPage from "../system/SystemMachineDetailPage";
import UConfirmDialog from "../../components/mui/UConfirmDialog";
import UAlertDialog from "../../components/mui/UAlertDialog";
import USnackbar from "../../components/mui/USnackbar";
import MachineForm from "./SystemMachineForm";
import UAuthFabAdd from "../../components/mui/UAuthFabAdd";
import USelectBox from "../../components/mui/USelectBox";
import { theme } from '../../assets/themes';
import UPopupForm from "../../components/mui/UPopupForm";

const useYn = [{cd:'Y', name:'Y'}, {cd:'N', name:'N'}, ];

const SystemMachinePage = () => {
	const { t } = useTranslation();
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const [modelList, setModelList] = useState([]); //그룹 리스트
    const [modelDetailInfo, setModelDetailInfo] = useState({
      userLoginId: userLoginId,
      useYn: 'Y',
    }); //그룹 상세
    const [loading, setLoading] = useState(false);
    const [ searchVal, setSearchVal ] = useState({
      useYn: 'Y',
    }); // 검색어

    const [ confirmPopupOpen, setConfirmPopupOpen ] = useState(false); // confirm dialog
    const [ errorPopupOpen, setErrorPopupOpen ] = useState(false); // error dialog
    const [ showError, setShowError ] = useState(false);
    const [ errorMsg, setErrorMsg ] = useState(""); // api error message
    const [ snackOpen, setSnackOpen ] = useState(false);
    const [ snackSeverity, ] = useState('success');
    const [ snackMessage, setSnackMessage ] = useState('');
    const [ formOpen, setFormOpen ] = useState(false); // modify dialog
    const [models, setModels] = useState([]);

    const location = useLocation();
    
    //화면 로드 시
    useEffect(() => {
      handleSearch();
      loadComboBoxModel()
    }, [])
    const loadComboBoxModel = async() => {
      try{
        const res = await getAPI(API.COMMON.MODEL);
        const _inputData = res.data.result.map((m) => ({
          cd: m.machKndCd,
          name: m.machKndCd,
        })
        );
        setModels(_inputData );
      }catch(e){
          console.error(e.message);
      }
    };
    //검색 조건 setter
    const handleChange = (e) => {
      const { name, value } = e.target;
      setSearchVal({
        ...searchVal,
        [name] : value
      })
    }

  //입력 데이타 유효성 검사
  const errors = useMemo(() => {
    const errors = {};
    if ( !modelDetailInfo.machKndCd ) {
      errors.machKndCd = fni18n('필수 입력 항목입니다')//'기종코드는 필수 입력 항목입니다.'
    } 
    if ( !modelDetailInfo.machKndNm ) {
      errors.machKndNm = fni18n('필수 입력 항목입니다')//'기종명은 필수 입력 항목입니다.'
    }
    if ( modelDetailInfo.machKndCd && modelDetailInfo.machKndCd.length > 5 ) {
      errors.machKndCd = fni18n('최대 길이가 5입니다')//'기종코드은 최대 길이가 5입니다.'
    }
    if ( modelDetailInfo.machKndNm && modelDetailInfo.machKndNm.length > 10 ) {
      errors.machKndNm = fni18n('최대 길이가 10입니다')//'기종명는 최대 길이가 10입니다.'
    }
    return errors;
  }, [modelDetailInfo])

  // 검색 함수
  const handleSearch = async() => {
    try {
      setLoading(true);
      await getAPI(API.SYSTEM.MACHINE, searchVal)
      .then((res) => {
        setModelList(res.data.result)
      })
      .catch((err) => {
        console.log(err)
      })
    } catch (error) {
      console.log(error)
    }
    setLoading(false);
  }
  // 상세 정보 변경 시 setter
  const onDetailChange = (e) => {
    const { name, value } = e.target;
    setModelDetailInfo({
      ...modelDetailInfo,
      [name] : value,
    });
  };
  //DataGrid에서 row 선택 시 
  const onSelectedRow = (row) => {
    // setModelDetailInfo(row)
    setModelDetailInfo({
      ...row,
      userLoginId : userLoginId,
    });
    handleFormOpen()
  };
  // 저장함수
  const handleSave = async() => {
    if ( Object.keys(errors).length > 0 ) {
      // handleErrorOpen()
      setShowError(true)
      return;
    }
    try {
      await postAPI(API.SYSTEM.MACHINE, modelDetailInfo)
      .then((res) => {
        if (res.data.code === 200) {
          //handleCancel();
          handleSearch();
          // snack bar success open
          setSnackMessage(res.data.message);
          handleClick();
          handleFormClose()
        } else {
          // setErrorMsg(res.data.message || "Processing failed.")
          setErrorMsg(t("처리가 실패하였습니다"))
          handleErrorOpen()
        }
      })
      .catch((err) => {
        console.log('>>', err)
      })
    } catch (error) {
      console.log('>>>', error)
    }
  }
  // 삭제함수
  const handleDelete = () => {
    // if ( Object.keys(errors).length > 0 ) {
    //   return;
    // }
    try {
      deleteAPI(API.SYSTEM.MACHINE, {machKndCd: modelDetailInfo.machKndCd, userLoginId: userLoginId})
      .then((res) => {
        if(res.data.code === 200) {
          // handleCancel();
          handleSearch();
          // snack bar success open
          setSnackMessage(res.data.message);
          handleClick();
          handleFormClose()
        } else {
          // setErrorMsg(res.data.message || "Processing failed.")
          setErrorMsg(t("처리가 실패하였습니다"))
          handleErrorOpen()
        }
      })
    } catch (error) {
      console.log(error)
    } finally{
      handleConfirmClose()
    }
  }
  // 되돌리기 함수
  const handleCancel = () => {
    setModelDetailInfo({
      userLoginId: userLoginId,
      useYn: "Y",
    })
    setShowError(false)
  }

  //삭제 확인 팝업 열기 함수
  const handleConfirmOpen = () => {
    // if ( Object.keys(errors).length > 0  || modelDetailInfo.useYn === 'N') {
    //   return;
    // }
    setConfirmPopupOpen(true);
  };
  //삭제 확인 팝업 닫기 함수
  const handleConfirmClose = () => {
    setConfirmPopupOpen(false);
  };

  //오류팝업 열기 함수
  const handleErrorOpen = () => {
    setErrorPopupOpen(true);
  };
  //오류팝업 닫기 함수
  const handleErrorClose = () => {
    setErrorMsg("")
    setErrorPopupOpen(false);
  };
  //성공 스낵바 열기 함수
  const handleClick = () => {
    setSnackOpen(true);
  };
  //성공 스낵바 닫기 함수
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpen(false);
  };
  //신규등록
  const handleAddNew = () => {
    handleCancel()
    handleFormOpen()
  }
  //폼 팝업
  const handleFormOpen = () => {
    setFormOpen(true);
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };
  // 상세 YN 변경 시 setter
  const onSwitchChange = (e) => {
    setModelDetailInfo({
      ...modelDetailInfo,
      [e.target.name]: e.target.checked === true ? "Y" : "N",
    });
  };
  /**
   * main list column set
   */
  const columns = [
    /*
    {
      field: "id",
      headerName: "번호",
      width: 70,
      headerAlign: "center",
      align: "center",
    },
    */
    {
      field: "machKndCd",
      headerName: "기종",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    /*{
      field: "machKndNm",
      headerName: "기종명",
      width: 200,
      headerAlign: "center",
      align: "center",
    },*/
    {
      field: "machKndDesc",
      headerName: "설명",
      width: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "jrnlYn",
      headerName: "명세표여부",
      width: 100,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params)=>{
        if (params.value == 'Y') {
          return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
        } else {
          return <Checkbox checked={false} disabled/>
        }
      },
    },
    {
      field: "billYn",
      headerName: "지폐부여부",
      width: 100,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params)=>{
        if (params.value == 'Y') {
          return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
        } else {
          return <Checkbox checked={false} disabled/>
        }
      },
    },
    {
      field: "coinYn",
      headerName: "동전부여부",
      width: 100,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params)=>{
        if (params.value == 'Y') {
          return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
        } else {
          return <Checkbox checked={false} disabled/>
        }
      },
    },
    {
      field: "cameraYn",
      headerName: "카메라여부",
      width: 100,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params)=>{
        if (params.value == 'Y') {
          return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
        } else {
          return <Checkbox checked={false} disabled/>
        }
      },
    },
    {
    field: "regDt",
        headerName: "등록일자",
        width: 150,
        headerAlign: "center",
        align: "center",
        /*valueFormatter: (params) => {
            if (params.value == null) {
                return "";
            }
            const valueFormatted = params.value.replace(
                    /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g,
                    "$1-$2-$3"
                );
            return `${valueFormatted}`;
        },*/
    },
    {
      field: 'modify',
      headerName: '설정',
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
      (
        <UButton
        variant="outlined"
        // onButtonClick={handleFormOpen}
        onButtonClick={()=>onSelectedRow(params.rows)}
        menuFrom={location.pathname}
        >
        보기
        </UButton>
      ),
    },
  ];

  return (
    <div className="main-container">
      <div className="header">
        <Grid container>
          <Grid item xs={10}>
            {/* 상단메뉴명 */}
            <UBreadCrumbs
                title={"시스템관리"}
                subtitle={"기종관리"}
                />
          </Grid>
          <Grid item xs={2}>
            {/* 툴바 버튼 */}
            <Stack 
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-start"
              spacing={0.5}
            >
              {/* <UAuthButton icon="Add" menuFrom={location.pathname} onButtonClick={handleAddNew}>추가</UAuthButton> */}
              {/* <UButton icon="Down" onButtonClick={(e)=>fnExcel(columns,modelList,e)}>엑셀</UButton> */}
              {/* <UButton icon="Search" onButtonClick={handleSearch}>조회</UButton> */}
            </Stack>
          </Grid>
        </Grid>
      </div>
        {/* <Divider/>  */}
        
        <Box className="contents">
        {/* 조회조건 */}
            <TableContainer className="table-container" component={Paper} elevation={0}>
            <Table className="table" size="small">
              <TableBody>
                <TableRow className="table-row-header">
                    <TableCell className="table-cell-title">{fni18n('기종번호')}</TableCell>
                    <TableCell className="table-cell">
                      {/* <UTextField
                        name="machKndCd"
                        onChange={handleChange} 
                        />  */}
                        <USelectBox
                        name="machKndCd"
                        items={models}
                        onItemChange = {handleChange}
                        />
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('기종명')}</TableCell>
                    <TableCell className="table-cell">
                      <UTextField
                      name="machKndNm"
                      onChange={handleChange} 
                      /> 
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                    <TableCell className="table-cell">
                      <USelectBox
                          id="useYn"
                          name="useYn"
                          items={useYn}
                          onItemChange={handleChange}
                          defaultValue={searchVal.useYn}
                        />
                    </TableCell>
                    <TableCell className="table-cell"></TableCell>
                    <TableCell className="table-cell"></TableCell>
                </TableRow>
              </TableBody>
            </Table>
            </TableContainer>
            <div className="search">
              <UButton icon="Search" onButtonClick={handleSearch}>조회</UButton>
          </div>
          {/* <Divider/> */}

          {/* 조회 리스트 */}
          <div style={{  width: "100%", display: "grid" }}>
            {/* <UDataGrid columns={columns} data={modelList} onSelectedRow={onSelectedRow} />  */}
            <UTable columns={columns} rows={modelList} rowPerPage={11}
            toolbarAdd={
              <UAuthButton icon="Add" menuFrom={location.pathname} onButtonClick={handleAddNew}>추가</UAuthButton>
            }   
            />
          </div>
        </Box> 

        {/* 상세 처리 버튼 리스트 */}
        {/* 조회 리스트 선택 상세  */}
        {/*
        <Box sx={{ p: 1 }}>
        <Grid container>
          <Grid item xs={9}>
          </Grid>
          <Grid item xs={3}>
          <Stack direction="row" spacing={2}>
            <FormControl sx={{ width: btnSize_wid }}>
              <UButton
                icon="Save"
                onButtonClick={handleSave}
              >
                저장
              </UButton>
            </FormControl>
            <FormControl sx={{ width: btnSize_wid }}>
              <UButton
                icon="Delete"
                onButtonClick={handleConfirmOpen}
              >
                삭제
              </UButton>
            </FormControl>
            <FormControl sx={{ width: btnSize_wid }}>
              <UButton
                icon="Cancel"
                onButtonClick={handleCancel}
              >
                취소
              </UButton>
            </FormControl>
            </Stack>
          </Grid>
        </Grid>
        </Box>

        <SystemMachineDetailPage 
        data={modelDetailInfo} 
        onChange={onDetailChange}
        errors={errors}
        showError={showError}
        />
        */}
        {/* 삭제 확인 팝업  */}
        <UConfirmDialog
        message={'[' + modelDetailInfo.machKndCd + ']' + modelDetailInfo.machKndNm + ' Are you sure you want to delete?'}//기종을 삭제하시겠습니까?
        open={confirmPopupOpen}
        onClose={handleConfirmClose}
        onClickOk={handleDelete}
        />

        {/* 오류 확인 팝업  */}
        <UAlertDialog
        alerts={errors}
        message={errorMsg}
        open={errorPopupOpen}
        onClose={handleErrorClose}
        />

        {/* 성공 스낵바  */}
        {/* <USnackbar
        open={snackOpen}
        onClose={handleClose}
        severity={snackSeverity}
        message={snackMessage}
        /> */}

        {/* 수정폼 팝업  */}
        {/* <MachineForm
        title={fni18n("기종관리")}
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleSave}
        onDelete={handleConfirmOpen}
        detailInfo={modelDetailInfo} 
        onDetailChange={onDetailChange} 
        errors={errors}
        showError={showError}
        /> */}
        <UPopupForm
          open={formOpen}
          onClose={handleFormClose}
          onSave={handleSave}
          title="기종 설정"
          type={"2"}
          content={
            <SystemMachineDetailPage 
            data={modelDetailInfo} 
            onChange={onDetailChange}
            errors={errors}
            showError={showError}
            onSwitchChange={onSwitchChange}
            />
          }
        /> 

        {/* 추가버튼 */}
        {/* <UAuthFabAdd menuFrom={location.pathname} onClick={handleAddNew} /> */}
    </div>

  );
}
export default SystemMachinePage;